import readXlsxFile, { URL } from 'read-excel-file'
import Papa from 'papaparse';
import { saveAs } from "file-saver";
import axios from 'axios';

function isValidUrl(url) {
  const pattern = new RegExp(
    "^(https?:\\/\\/|www\\.)?" + // پروتکل‌های مختلف یا www
      "(localhost|(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" + // localhost یا دامین
      "(\\d{1,3}(\\.\\d{1,3}){3}))" + // آی‌پی‌ها
      "(\\:\\d+)?" + // پورت (اختیاری)
      "(\\/[-a-zA-Z\\d%_.~+]*)*" + // مسیر
      "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // کوئری پارامتر
      "(\\#(\\/[-a-zA-Z\\d%_.~+]*)?)?$", // هشتگ با مسیر اختیاری
    "i"
  );
    return !!pattern.test(url);
  }
  function IsValidUrl2(url){
    try{
        new URL(url);
        return true;
    }catch(err){
        return false;
    }
  }

  async function readLinksFromXlsxFile(file) {
    try {
      let rows = await readXlsxFile(file); 
      if (!rows || rows.length === 0) return { titles: [], links: [] };      
      let links = [];
      let titles = [];
      for (let row of rows) {
        let title = row[1]?.toString()?.trim() || "";
        let validlink = row[0]?.toString()?.trim() || "";

        if (isValidUrl(validlink) && IsValidUrl2(validlink)) {
          links.push(validlink);
          if (!title?.trim()) {
            title = titles[titles.length - 1] || "Title";
            if (title.includes('(')) {
              title = `${title.split('(')[0]}(${parseInt(title.split('(')[1].split(')')[0], 10) + 1})`;
            } else {
              title = `${title}(1)`;
            }
          }
          titles.push(title);

        }
      }
      return { titles, links };

    } catch (error) {
      console.error("Error reading XLSX file:", error);
      return { titles: [], links: [] };
    }
  }
  async function fetchShortLinks(){
    try{
    const response  = await axios.get("https://t7r.ir/api/link",
      {
        headers: {
          Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NzBjNGM2MC03NjMxLTQ4YTYtYWYzOS02MmY0Y2Q4NGVjMTkiLCJqdGkiOiI4NjY0NGUzNDRkMWQ0MmUzYWQxOTI0YjgwMWRhMmMwMTBhYWEyMWU3NDNhNmVkOWZmYjI1ODU5ZmQ3YWI1OWY2ZGI4M2NjYjZjYzA3OTJlYiIsImlhdCI6MTc0MjAxNjg5NS44MjIzMzUsIm5iZiI6MTc0MjAxNjg5NS44MjIzNDIsImV4cCI6MTc0MzMxMjg5NS43NzYyODEsInN1YiI6IjMiLCJzY29wZXMiOltdfQ.f3qeFmYXIfrS32L6xp0JgFasMQEZX9BM7xBtWOZUUD8ZGDHXs4J4Sgz2RJiFC83mFcaN9pLifb0m5EIUUNkXJTCLKsLlJpp1rJS8OBiM4o6zxOIYe24Ah4FvNeJJCb_T-hewenxQGlmEOVgwntpPDoIAxIy_SfaPQu8ZhY4qnImFPTg2QUClWhKLspy5JsrlC5GkbkoeMbrhUdmBjFxx6dMsrz9yIsVaBDeWA_8yjzrQNQyyobiWwjPCMH7d_ZEp0N75V9avfe-7vqumMIrfhKXSc7ZGec8hlwIxCMiAgM7P7Lulo-Ubpvx3iBZBpAZ0BA5XotaHt9-vg8x1XUuu9VCBzRUg0VN1A_GfR7JGJbWVZpPxbqjzB6DXMALkJfg6Q-RxFbMFQmiCX1A2R-mFEv68MTqHnujvTjEykv-inl2NI7sFBWwAqlwbR58jWacfRVVUpb9ITFAigql6sYMYT23cbcMMtxDeDgDdalGADKIGaY2B3A2wujIItq-sMB_Ji93ZjsYD3s18lvcCB0jYEsRZkn1wvBXO8MoomUMPlUwbDsqXzEARXpwFBqF4a7Fqfi6ewCn9n__iDfd_LkUH-XXkvG9wFaqwpRxIWRobKb9MgOdWxtI8dr24e52fUL16bo_oOX58l7nuxEBTQ5Trvy2HcxcWmqyM6hvtLVUgaVk`,
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    console.log('data',data.data);
    if(Array.isArray(data.data)){
        const filteredData = response.data.data.map(item => ({
            id: item.id,
            shortUrl: `${item.domains.domain}/${item.code}`,
            longUrl: item.link,
            create_at: new Date().toISOString().split('.')[0],
            domin: item.domains.domain,
            title: item.title,
            id_user: item?.id_user?? 1 ,// for test 
            active: true,
            views: item.viewsC,
            updated_at:"",
            ended_at:null
        }))
        return await filteredData;
    }else{
        console.error("داده دریافت شده از سرور معتبر نیست:", data);
    }}
    catch(err){
        console.error("خطا در دریافت داده از سرور:", err);
    }
}

  function readLinksFromCsvFile(file) {
    return new Promise((resolve, reject) => {
      if (!file || !file.type) {
        console.error("Invalid file provided.");
        return reject(new Error("Invalid file provided."));
      }
  
      let filereader = new FileReader();
  
      filereader.onload = function () {
        try {
          let lines = filereader.result
            .split("\n")
            .filter((line) => line.trim() !== "");
            
          let links = [];
          let titles = [];
  
          for (let line of lines) {
            let parts = line.split(",");
            let validlink = parts[0]?.trim() || "";
            let title = parts[1]?.trim() || "";
  
            if (IsValidUrl2(validlink)) {
              links.push(validlink);
  
              if (!title) {
                title = titles[titles.length - 1] || "Title";
                if (title.includes("(") && title.includes(")")) {
                  let num = parseInt(title.split("(")[1].split(")")[0], 10);
                  title = `${title.split("(")[0]}(${isNaN(num) ? 1 : num + 1})`;
                } else {
                  title = `${title}(1)`;
                }
              }
              titles.push(title);
            }
          }
  
          resolve({ titles, links });
        } catch (error) {
          console.error("Error processing file:", error);
          reject(error);
        }
      };
  
      filereader.onerror = function (error) {
        console.error("File read error:", error);
        reject(error);
      };
  
      filereader.readAsText(file);
    });
  }
  
function readLinksFromTextFile(file, callback) {
  return readLinksFromCsvFile(file, callback);
}

function convertTableToCsv(headers,items) {
  if (!headers || headers.length === 0 || !items) {
    console.error("هدر یا فیلدهای جدول معتبر نیست");
    return "";
  }  
  let cvsContent = "";
  let filterheader = headers.slice(1,-1);
  cvsContent += filterheader.map(header => header.text).join(",")+"\n";
  items.forEach(row => {
    let rowData = filterheader.map(header=>row[header.value]?? "").join(",");
    cvsContent += rowData + "\n";
  });
  console.log('cvscontent',cvsContent);
  return cvsContent;
}
function downloadCvsFile(cvsContent,filename="data.csv"){
  console.log('cvsContent12',cvsContent);
  let bom = "\uFEFF";

  let blob = new Blob([bom + cvsContent], { type: "text/csv;charset=utf-8;" });
  console.log('blob',blob);
  if (!(blob instanceof Blob)) {
    console.error("خطا: blob نامعتبر است!");
    return;
  }
  saveAs(blob,filename);
}

async function validateLink(url) {
  let valid = []
  let invalid = []

  for (let url of urls) {
    if (isValidUrl(url)) {
      valid.push(url)
    } else {
      invalid.push(url)
    }
  }
  return {valid, invalid}
}


async function filterCorrectLinks(urls) {
  let arr = urls?.filter(item => {
    return isValidUrl(formatToLink(item))
  }).map(item => formatToLink(item))

  return [...new Set(arr)]
}

function isLinkInText(text) {
  return /(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]/.test(text);
}
function checkUrl(url) {
  let protocol_ok =
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("ftp://");

  if (!protocol_ok) {
    return "https://" + url;
  }

  if (url.startsWith("http://")) {
    return url.replace("http://", "https://");
  }

  return url;
}

function removehttp(url) {
  return url.toLowerCase().replace(/^(https?:\/\/|ftp:\/\/)?(www\.)?/i, "");
}

export {
  removehttp,
  checkUrl,
  isValidUrl,
  readLinksFromXlsxFile,
  readLinksFromCsvFile,
  readLinksFromTextFile,
  validateLink,
  filterCorrectLinks,
  isLinkInText,
  convertTableToCsv,
  IsValidUrl2,
  downloadCvsFile,
  fetchShortLinks,
}